module.exports = __webpack_public_path__ + "static/media/live-stream.422ef7ba.png";